import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";
import ConfirmDestroyView from "./index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  methods: {
    handleClickConfirmDestroyViewClose() {
      this.$store.commit("pages/plan/updateConfirmDestroyView", {
        isVisible: false
      });
    },
    handleEditEventViewClose() {
      this.$store.commit("pages/plan/updateEditEventView", {
        isVisible: false
      });
    },
    handleCreateEventViewClose() {
      this.$store.commit("pages/plan/updateCreateEventView", {
        isVisible: false
      });
    },
    async handleClickClose() {
      this.handleClickConfirmDestroyViewClose();
      this.handleEditEventViewClose();
      this.handleCreateEventViewClose();
    }
  },
  render(createElement) {
    return createElement(ConfirmDestroyView, {
      on: {
        clickClose: this.handleClickClose,
        clickConfirmDestroyViewClose: this.handleClickConfirmDestroyViewClose
      }
    });
  }
});
